<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId && (editMode || storyId)"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :use-example-data="editMode"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import LayoutCardSize from "%/dynamic-component-editor/options/layout-card-size";
import StoryContextSelection from "%/dynamic-component-editor/options/story-context-selection";
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";
import { Context } from "%/dynamic-component-editor/classes/context-v2";
import ProvidesContextEntry from "%/dynamic-component-editor/classes/provides-context-entry";
import { useReadStatusStore } from "%/dynamic-component-editor/stores/read-status-store";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";

export default {
  name: "StoryContextCard",
  components: { DynamicComponentProduction },
  mixins: [DynamicElementMixin, BaseStoryCardElementMixin, DcHostMixin],
  provide() {
    return {
      pageEntities: () => {
        const parent = typeof this.pageEntities === "function" ? this.pageEntities() : this.pageEntities;
        return { ...parent, story: this.storyId };
      },
    };
  },
  relatedComponents: ["Story Card", "Large Story Card"],
  elementPanelSettings: {
    displayName: "Story Card (Context)",
    displayIcon: "prime:book",
    elementGroup: "general",
    elementType: "element",
  },
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-height": "hug",
      "default.layout-width": "hug",
    }),
  ],
  options: [
    ReferencedComponentId,
    ContextBindings,
    LayoutCardSize,
    StoryContextSelection,
  ],
  data() {
    return {
      StoryContextSelection,
    };
  },
  computed: {
    storyId() {
      const contextName = this.getOptionValue(StoryContextSelection);
      if (!contextName) {
        return 0;
      }
      const context = Context.contexts[contextName];
      if (!context) {
        return 0;
      }
      return context.pk.id;
    },
    defaultComponentName() {
      const cardSize = this.getOptionValue(LayoutCardSize);
      return cardSize === "small" ? "Story Card" : "Large Story Card";
    },
  },
  created() {
    // The resume context carries no pk until something asks for it — a request
    // most pages never need. Binding this card to it is that ask.
    if (this.editMode || this.isPreviewMode) {
      return;
    }
    const contextName = this.getOptionValue(StoryContextSelection);
    if (Context.getContext(contextName)?.standardEntity === ProvidesContextEntry.KEY_STANDARD_RESUME_STORY) {
      useReadStatusStore().loadResumeStory();
    }
  },
};
</script>
